import { Div } from "../../../base/components/native/div"
import { H1 } from "../../../base/components/native/h"
import * as styles from "./title.style"

export const Title = () => {
    const base = H1()
    base.cssClass(styles.baseStyle)
    base.text('🏭 Funnel Builder 2')

    return base
}